import React, { useState, useEffect } from 'react';
import taxi from './belfast-cab-tour-home.png';
import tripadvisor from './tripadvisor.svg';
import checkmark from './check-mark.svg';
import '../Styles.css';

const CheckmarkIcon = <img src={checkmark} alt="checkmark-logo" className="checkmark-logo" />;

function Home() {
  // State to store the current scroll position
  const [scrollTop, setScrollTop] = useState(0);

  // Set up a scroll event listener to track scroll position
  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY); // Get the scroll position
    };

    window.addEventListener('scroll', handleScroll); // Add event listener
    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up on component unmount
    };
  }, []);

  return (
    <div>
      {/* Header Section */}
      <header className="Home-header">
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="taxi"
            style={{
              top: '10%', // Adjust this value to raise the taxi
              transform: `translateY(-${scrollTop / 100}%)`, // Dynamic scroll effect
            }}
          />
        </div>
      </header>

      <div className="Home-content-divider"><br /></div>

      {/* Header Text */}
      <div className="header-container">
        <h1 className="Home-header1">
          Discover Belfast <br/>
          and the Giant's Causeway <br/>
          with Black Taxi Cab Tours
        </h1>
      </div>

      <div className="Home-content-divider"><br /></div>

      {/* TripAdvisor Button */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
      }}>
        <a
          href="https://www.tripadvisor.co.uk/Attraction_Review-g186470-d6214851-Reviews-Tours_By_Taxi_Belfast-Belfast_Northern_Ireland.html"
          target="blank"
          style={{ textDecoration: 'none' }}
        >
          <button style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#00a680',
            border: 'none',
            borderRadius: '5px',
            padding: '5px 10px',
            color: 'white',
            fontSize: '20px',
            cursor: 'pointer',
            fontFamily: 'Arial, sans-serif',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'background-color 0.3s ease',
          }}>
            <img
              src={tripadvisor}
              alt="TripAdvisor Logo"
              style={{ width: '35px', height: '35px', marginRight: '10px' }}
            />
            <strong>Find us on TripAdvisor</strong>
          </button>
        </a>
      </div>

      <div className="Home-content-divider"><br /></div>

      {/* Main Content */}
      <div className="Home-content">
        <h2>
          <p>
            Welcome to Belfast Cab Tour, a leading provider of taxi tours in Belfast, Northern Ireland.
            <br /><br />
            Experience the rich history, vibrant culture, and iconic landmarks of this incredible city from the comfort of our private taxi tours.
          </p>
          <p>
            Whether you're a history buff, a Game of Thrones fan, or simply eager to explore the famous Belfast murals, we have a tour for you!
          </p>
        </h2>
      </div>

      <div className="Home-content-divider"><br /></div>

      <div className="Home-content1">
        <h2>Why Choose Our Belfast Taxi Tours?
        <br /><br />
        <ul>
          <li>
            {CheckmarkIcon}
            <span>
            <strong>Local Expertise:</strong> Our friendly drivers are knowledgeable guides who know Belfast inside out.
            </span>
          </li>
          <li>
            {CheckmarkIcon}
            <span>
            <strong>Customized Experiences:</strong> Choose from curated tours or create a bespoke journey tailored to your interests.
            </span>
          </li>
          <li>
            {CheckmarkIcon}
            <span>
            <strong>Comfort & Convenience:</strong> Travel in style and comfort with clean, modern vehicles designed for small groups and families.
            </span>
          </li>
          <li>
            {CheckmarkIcon}
            <span>
            <strong>Unbeatable Locations:</strong> From Titanic Belfast to the Peace Walls, we cover all the must-see spots.
            </span>
            </li>
        </ul>
        </h2>
      </div>

      <div className="Home-content2">
        <h3>Top-Rated Cab Tours in Belfast</h3>
        <ul>
          <li><strong>Belfast Political Taxi Tour:</strong> Learn about Northern Ireland’s complex history and visit popular locations like the Falls Road and Shankill Road.</li>
          <li><strong>Giant’s Causeway and Coastal Tour:</strong> Discover the breathtaking Antrim Coast and the legendary Giant’s Causeway.</li>
          <li><strong>Game of Thrones Cab Tour:</strong> Explore filming locations across Northern Ireland.</li>
        </ul>

        <h3>Affordable Belfast Taxi Tours</h3>
        <p>
          Our tours offer exceptional value. Call us today for a quote tailored to your needs.
        </p>

        <h3>Book Your Belfast Cab Tour Today!</h3>
        <p>
          Don’t miss out on the ultimate way to explore Belfast. Call us now to secure your spot!
          <br /><br />
          <a href="tel:+447773600624">
            <button className="call-us-button" id="call-button">
              Call us +447773600624
            </button>
          </a>
        </p>
      </div>

      <div className='Socials-icons'>
          <a href="https://www.facebook.com/profile.php?id=61571319634353" target="_blank" rel="noopener noreferrer">
             <i class="fab fa-facebook"></i>
          </a>
          <a href="https://www.instagram.com/belfastcabtour/?hl=en" target="_blank" rel="noopener noreferrer">
          <i class="fab fa-instagram"></i>
          </a>
      </div>

      {/* Footer */}
      <footer style={{
        marginTop: 'auto',
        textAlign: 'center',
        padding: '1rem',
        backgroundColor: '#333',
        color: '#fff',
      }}>
        &copy; 2025 <a href="https://belfastcabtour.com" style={{ color: '#fff', textDecoration: 'none' }}>belfastcabtour.com</a>. All rights reserved.
      </footer>
    </div>
  );
}

export default Home;
